import {
  DateRangeTimezoneValue,
  DateRangeValue,
} from 'shared/mui/DatePicker/DateRangeTimezonePicker/DateRangeTimezonePicker';
import { FilterFields } from 'shared/mui/Filter/FilterFields/FilterFields';

import { useExpenseReportFilterFields } from './hooks/useExpenseReportFilterFields';

export type ExpenseReportFilterFormValues = {
  appliedDate: DateRangeValue;
  timezone: DateRangeTimezoneValue;
  currency: string;
  referral?: number[];
  expenseTypes?: string[];
  expenseArticles?: string[];
  expenseSubarticles?: string[];
};

export const ExpenseReportListFilter = () => {
  const fields = useExpenseReportFilterFields();

  return <FilterFields fields={fields} />;
};
